import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import { DraggableModal } from "../../../../../components/DraggableModal";

enum FormField {
  alias,
  nameKy,
  nameRu
}

interface IProps {
  show: boolean;
  cropType: EntDirectoryInfoName;
  onHide: () => void;
  onSubmit: (pos: EntDirectoryInfoName) => Promise<boolean>;
}

export const AddTypesOfAgriculturalCrops = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
	if (props.show) setFieldsFromEntity();
  }, [props.show]);

  const setFieldsFromEntity = (): void => {
	form.setFields([
	  { name: FormField.alias, value: props.cropType.alias },
	  { name: FormField.nameKy, value: props.cropType.nameKy },
	  { name: FormField.nameRu, value: props.cropType.nameRu },
	]);
  }

  const setEntityFromFields = (): EntDirectoryInfoName => {
	let cropType = _.cloneDeep(props.cropType);
	cropType.alias = form.getFieldValue(FormField.alias);
	cropType.nameKy = form.getFieldValue(FormField.nameKy);
	cropType.nameRu = form.getFieldValue(FormField.nameRu);
	return cropType;
  }

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const result = await props.onSubmit(data);
	  if (result) props.onHide();
	} finally {
	  setLoading(false);
	}
  }

  return (
	<>
	  <DraggableModal
		title={props.cropType.id === 0 ? t('general.add') : t('general.edit')}
		visible={props.show}
		onCancel={props.onHide}
		onSubmit={handleSubmit}
		submitLoading={loading}
	  >
		<Form
		  initialValues={{ remember: true }}
		  autoComplete="off"
		  layout="vertical"
		  form={form}
		>
		  <Form.Item
			label={ t('general.alias') }
			name={FormField.alias}
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off" />
		  </Form.Item>
		  <Form.Item
			label={ t('general.nameKy') }
			name={FormField.nameKy}
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off" />
		  </Form.Item>
		  <Form.Item
			label={ t('general.nameRu') }
			name={FormField.nameRu}
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off" />
		  </Form.Item></Form>
	  </DraggableModal>
	</>
  )
}









